import { connect } from 'react-redux';
import PlayersList from './PlayersList';
import {listStateFromCRUD, listDispatchFromCrud} from '../../../selectors/crud';
import { setHeaderTitle } from '../../../actions/layout';
import {getCurrentClubId} from '../../../selectors/club-settings';
import { PLAYERS_ROUTER_NEW, PLAYERS_ROUTER_EDIT } from '../constants';
import { push } from 'react-router-redux/lib/actions';
import CRUDActions from '../../../actions/player';

export default connect(
  (state) => ({
    headerTitle: 'Player',
    ...listStateFromCRUD(state.player),
    filter: {
      club_id: getCurrentClubId(state)
    }
  }),
  (dispatch) => ({
    updateHeaderTitle: (title) => dispatch(setHeaderTitle(title)),
    ...listDispatchFromCrud(dispatch, CRUDActions),
    edit: (id) => dispatch(push(PLAYERS_ROUTER_EDIT.replace(':id', id))),
    add: () => dispatch(push(PLAYERS_ROUTER_NEW))
  })
)(PlayersList);




// WEBPACK FOOTER //
// ./src/components/Players/PlayersList/index.js